export default {
  isOpenModalNotifCotizaciones: false,
  showHideFormCotizaciones: false,
  showSendingText: false,
};
